<template>
    <div class="row mb-4">
        <div class="col-md-3 mb-4">
            <label class="form-label" for="is_iplicit">In Iplicit</label>
            <select class="form-select" id="is_iplicit" v-model="filters.is_iplicit">
                <option value="">All</option>
                <option value="0">No</option>
                <option value="1">Yes</option>
                <option value="blocked">Blocked</option>
            </select>
        </div>
        <div class="col-md-3">
            <label class="form-label" for="date_completed_gmt">Date Completed</label>
            <input class="form-control" id="date_completed_gmt" type="date" v-model="filters.date_completed_gmt">
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-md-2">
            <select class="form-select" v-model="limit">
                <option>25</option>
                <option>50</option>
                <option>100</option>
            </select>
        </div>
        <div class="col-md-4 ms-auto">
            <div class="input-group">
                <input type="text" class="form-control" v-model="searchTerm" placeholder="Search order number...">
                <span class="input-group-text bg-body border-0">
                    <i class="fa fa-search"></i>
                </span>
            </div>
        </div>
    </div>

    <datatable :url="ajaxUrl" :limit="limit" :orderBy="orderBy" :orderAsc="orderAsc" :search="searchTerm" :filters="filters">
        <template #headings>
            <th v-if="props.hideCustomer === false">Customer</th>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="date_completed_gmt">Date Completed</sortableTh>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="woocommerce_order_id">Order</sortableTh>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="total">Total</sortableTh>
            <th>Status</th>
            <th>Payment</th>
            <th></th>
        </template>
        <template #rows="{data}">
            <tr v-for="order in data" :key="order.id">
                <td v-if="props.hideCustomer === false">{{ order.customer_name }}</td>
                <td>{{ order.date_completed_gmt }}</td>
                <td>{{ order.woocommerce_order_id }}</td>
                <td>{{ order.total }}</td>
                <td>{{ order.woocommerce_status }}</td>
                <td>
                    <span v-if="order.has_payment_allocation === null">Blocked</span>
                    <i v-else-if="order.has_payment_allocation === true" class="fa fa-check text-success"></i>
                    <i v-else class="fa fa-times text-danger"></i>
                </td>
                <td v-html="order.actions"></td>
            </tr>
        </template>
    </datatable>
</template>

<script setup>
import datatable from '@/components/datatable.vue';
import sortableTh from '@/components/datatable/sortableTh.vue';
import { reactive, ref } from "vue";

const props = defineProps({
    ajaxUrl: String,
    hideCustomer: Boolean,
});

const orderBy = ref('date_completed_gmt');
const orderAsc = ref(false);
const limit = ref(25);
const searchTerm = ref(null);
const filters = reactive({
    is_iplicit: '1',
    date_completed_gmt: '',
});

const setOrder = function (input) {
    if (orderBy.value == input) {
        orderAsc.value = ! orderAsc.value;
    } else {
        orderBy.value = input;
        orderAsc.value = true;
    }
};
</script>
